<template>
    <div class="user-info" v-loading="loading">
        <div class="collect-head">
            <div class="topic-search">
<!--                作品标题 <input type="text" class="search-input" placeholder="请输入" v-model="searchKey">-->
                <button type="button" class="btn btn-primary" @click="search">刷新</button>
            </div>



        </div>
        <el-table :data="tablePager.list" style="width: 100%">
            <!--            <el-table-column type="selection"  width="55"/>-->
            <!--            <el-table-column type="index" label="序号" width="80"/>-->
            <el-table-column prop="name" label="名称"/>
            <el-table-column prop="projectNumber" label="参评年度"/>
            <el-table-column prop="unitName" label="参评单位"/>
            <el-table-column prop="subTime" label="提交时间"/>
            <el-table-column prop="stateName" label="状态"/>
            <el-table-column label="操作" width="220">
                <template #default="scope">

                    <el-button v-if="scope.row.recordId" style="margin-top: 10px;" type="success" size="small" @click="showDetail(scope.row.recordId)">查看详情</el-button>


                    <el-button v-if="scope.row.projectNumber !== '2025' && ((!scope.row.state) || (scope.row.state === 0 || scope.row.state === 2 || scope.row.state === 4))" style="margin-top: 10px;" type="primary" size="small" @click="showEdit(scope.row)">填报</el-button>



                    <el-button style="margin-top: 10px;" type="warning" size="small" @click="showLogApprList(scope.row.recordId)">查看审核记录</el-button>

                </template>


            </el-table-column>
        </el-table>
<!--        <Pager :totalPage="tablePager.totalPage" :currentPage="currentPage" @pageChange="pageChange" class="pager"/>-->



    </div>
</template>

<script>
import SearchBar from '../../../components/common/SearchBar'
import {ElTable, ElTableColumn, ElButton, ElDialog, ElResult, ElPopover, ElIcon,ElMessage} from 'element-plus';
import {MoreFilled} from '@element-plus/icons-vue'
import Pager from '../../../components/common/Pager'
import {ref, onMounted, computed, getCurrentInstance} from 'vue';
import CommonUtil from "@/utils/common"

export default {
    components: {SearchBar, ElTable, ElTableColumn, ElButton, ElIcon, ElDialog, ElResult, ElPopover, MoreFilled, Pager,ElMessage},
    setup() {
        const {proxy} = getCurrentInstance();
        const currentPage = ref(1);
        const loading = ref(false);


        const searchKey = ref('');
        const tablePager = ref({
            total: 1,
            page: 1,
            list: []
        })

        function loadData() {
            loading.value = true;
            const url = '/gdsti2/estimate/c/estProjectInfo/userGetList';
            proxy.$http.post(url, {
                limit: 10,
                offset: (currentPage.value - 1) * 10,
                searchValue: searchKey.value,
                isMy: 1,
            })
                .then(res => {
                    loading.value = false
                    if (res.data.state == 0) {
                        tablePager.value = res.data.result;
                    }
                }).catch(err => {
                loading.value = false
            })
        }



        function pageChange(index) {
            currentPage.value = index;
            loadData();
        }

        function search() {
            pageChange(1);
        }



        //查看详情
        async function showEdit(row) {
            let _this = this;
            let recordId = row.recordId;
            if (!recordId) {
                //如果没有记录id，先保存
                let applyProjectParam = {
                    projectId: row.id,
                    vCode: row.vCode,
                }
                await proxy.$http.post(`/gdsti2/estimate/c/estProjectRecord/applyProject`, applyProjectParam)
                    .then(res => {
                        recordId = res.data.result;
                    }).catch(err => {

                    })


            }
            //判断是否已经关联了仪器
            proxy.$http.post(`/gdsti2/estimate/c/estRecordRelateInstru/checkInstrumentBinding`, {
                projectRecordId: recordId,
            }).then(res => {
                if (res.data.result === false) {
                    //未关联

                    //弹出关联仪器设备对话框
                    let dialogId = 'projectInput' + Math.floor(Math.random() * 1000000);
                    openDialog(dialogId, '请选择参与绩效评审的仪器设备（仅显示审核通过的数据）', '/gdsti2v/resource/resCatalogInfo/selectResource?examineStatus=1&isSingle=false&catalogType=INSTRUMENT_DATA', {}, '95%', '95%', function (callbackData) {

                        if (callbackData.selectItemArr && callbackData.selectItemArr.length > 0) {
                            console.log(callbackData.selectItemArr)
                            HFConfirm("提示", "您共选择了" + callbackData.selectItemArr.length + "台仪器，参评仪器如需修改，请在绩效评价表单“参与评审的仪器设备”模块中进行增加或删除。", '', function (action) {
                                if (action) {

                                    let editPram = {
                                        projectRecordId: recordId,
                                        instrumentIds: callbackData.selectItemArr.map(item => item.id).join(',')
                                    }
                                    //保存关联的仪器设备
                                    proxy.$http.post(`/gdsti2/estimate/c/estRecordRelateInstru/edit`, editPram).then(res => {
                                        HFToastrTipResult(res.data);
                                        if (res.data.state == 0) {
                                            //弹出大仪考核评估详情页
                                            openDialog('estimateestProjectInfoAddInstru', '填报', '/gdsti2v/estimate/estProjectRecord/formMultiInstru?projectRecordId=' + recordId, {}, '95%', '95%', function (callbackData) {
                                                loadData();
                                            });
                                        }
                                    }).catch(err => {
                                    })
                                }
                            })

                        }
                    });
                } else {
                    //已关联
                    //大仪考核评估
                    openDialog('estimateestProjectInfoAddInstru', '填报', '/gdsti2v/estimate/estProjectRecord/formMultiInstru?projectRecordId=' + recordId, {}, '95%', '95%', function (callbackData) {
                        loadData();
                    });
                }
                console.log(res.data);

            }).catch(err => {

            })

            loadData();
        }

        function showDetail(id) {
            openDialog('showDetail', '详情', '/gdsti2v/estimate/estProjectRecord/formMultiInstru?disabled=true&projectRecordId=' + id, '', '95%', '95%', function () {
                loadData()
            });
        }

        function showLogApprList(id) {
            openDialog("showLogApprList","审核记录","/gdsti2v/base/logAppr/list?sourceType=EST_PROJECT_RECORD&sourceId="+ id,"",'95%', '95%',function(){

            });
        }

        function querySearch(queryString, cb) {

            const results = queryString
                ? formRecommendation.value.filter(createFilter(queryString))
                : formRecommendation.value
            // call callback function to return suggestions
            cb(results)
        }



        onMounted(async () => {

            loadData();     //加载数据

            let isLogin =  await CommonUtil.isLogin();

            if(isLogin){
                //登录了，判断角色
                let isUnitAdmin = await CommonUtil.isUnitAdmin();

                if (!isUnitAdmin) {
                    ElMessage.error('您没有权限，只有依托单位管理员才能进行此项操作。');
                    proxy.$router.push({name: 'Index', path: '/index'});
                }
            }

        })


        return {
            showDetail,
            showLogApprList,
            tablePager,
            pageChange,
            search,
            currentPage,
            loading,
            searchKey,
            querySearch,
            showEdit,
        }
    },

}
</script>

<style lang="less" scoped>
@import 'public/static/css/userBaseInfo.less';

.topic-search {

    line-height: 25px;
    font-size: 14px;


    .search-input {
        background: #FFFFFF;
        border: 1px solid rgba(0, 0, 0, 0.15);
        border-radius: 2px;
        padding: 5px 9px;
        margin-left: 9px;
        margin-right: 16px;
        font-size: 14px;
        line-height: 14px;
    }

    .btn {
        display: inline-block;
        padding-top: 2px;
        padding-bottom: 2px;
    }
}
</style>

